export const COLOR_MAP = {
  blue: '#629ef8',
  green: '#61cf67',
  red: '#d36262',
  purple: '#b561da',
  turquoise: '#5fdde4',
  yellow: '#fbc02d',
};

export const LIGHT_COLOR_MAP = {
  blue: '#c9ddfc',
  green: '#d0ffd2',
  red: '#ffcdd2',
  purple: '#e1bee7',
  turquoise: '#b2ebf2',
  yellow: '#fff3d6',
};

// Μπορείς να ορίσεις και ένα default αν θες
export const DEFAULT_COLOR = 'yellow';
